import React, {Component} from 'react';
import './Member.css';
import {Button, Steps} from 'antd';
import PersonalInfo from "../personalInfo/PersonalInfo";
import ContactInfo from "../contactInfo/ContactInfo";
import RuhsatInfo from "../ruhsatInfo/RuhsatInfo.js";
import MemberApproval from "../memberApproval/MemberApproval";
import FileUpload from "../fileUpload/FileUpload";
import {deepCopyObject, showAxiosError} from "../../util/Helpers";
import {request} from "../../util/APIUtils";
import Alert from "react-s-alert";
import CitySelection from "./CitySelection";
import {validateComponent} from "../../common/validation";
import moment from 'moment';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";


const Step = Steps.Step;

class Member extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            id: "", //
            cities: [],
            currentUser: [],
            edit: false,
            isLoading: false,
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                tcKimlikNo: "",
                dogumTarihi: "",
                kimlikTipi: "",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: "",
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",//
                odaSicilNo: "",//
                universite: "",
                mezuniyetTarihi: "",
                diplomaNo: "",
                ruhsatTarihi: "",
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                basvuruDurumu: "",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: false,
                uyelikAktif: false,
                borcuVar: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                city: {
                    id: null,
                    plakaKod: "",
                    ad: "",
                    oda: {
                        id: "",
                        ad: "",
                        adres: "",
                        telefonNo: "",
                        email: "",
                        webSitesiURL: "",
                        kurulusKararNo: ""
                    }
                }
            },
            infoValid: true,
            validationInfo:
                {
                    citySelectionValid: true,
                    citySelectionError: {},
                    personalInfoValid: true,
                    personalInfoError: {},
                    contactInfoValid: true,
                    contactInfoError: {},
                    ruhsatInfoValid: true,
                    ruhsatInfoError: {},
                    fileUploadValid: true,
                    fileUploadError: {}
                },
        };
        this.handleInfoChange = this.handleInfoChange.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.saveMember = this.saveMember.bind(this);
        this.getMemberForEdit = this.getMemberForEdit.bind(this);
        this.handleCityInfoChange = this.handleCityInfoChange.bind(this);
        this.handleStepValidation = this.handleStepValidation.bind(this);
        this.handleStepErrors = this.handleStepErrors.bind(this);
        this.validateMemberInfo = this.validateMemberInfo.bind(this);
    }

    componentDidMount() {
        let currentUser = this.props.location.currentUser;
        let edit = this.props.location.edit;
        this.setState({currentUser, edit});
        if (edit) {
            console.log("edit==>", edit);
            this.getMemberForEdit(currentUser);
        }
        this.listCities();
    }


    validateMemberInfo() {
        let memberInfo = this.state.memberInfo;
        let errorMessage = '';
        if (memberInfo.ad === null || memberInfo.ad.toString().trim() === '') {
            errorMessage += 'Ad Boş Olamaz!</br>';
        }

        if (memberInfo.soyad === null || memberInfo.soyad.toString().trim() === '') {
            errorMessage += 'Soyad Boş Olamaz!</br>';
        }

        if (memberInfo.tcKimlikNo === null) {
            errorMessage += 'TC Kimlik No Boş Olamaz!</br>';
        }

        if (memberInfo.tcKimlikNo.toString().trim().length !== 11) {
            errorMessage += 'TC Kimlik No Alanı 11 Hane Uzunluğunda Olmalıdır!</br>';
        }

        if (memberInfo.kimlikTipi === null) {
            errorMessage += 'Kimlik Tipi Seçiniz!</br>';
        }

        if (memberInfo.kimlikTipi === "TCKimlikKarti") {
            if (memberInfo.kimlikSonGecerlilikTarihi === null) {
                errorMessage += 'Kimlik Son Geçerlilik Tarihi Seçiniz!</br>';
            }
        } else if (memberInfo.kimlikTipi === "NufusCuzdani") {
            if (memberInfo.kayitNo === null || memberInfo.kayitNo.toString().trim() === '') {
                errorMessage += 'Kimlik Kayıt No Giriniz!</br>';
            }
        }

        if (memberInfo.anaAdi === null || memberInfo.anaAdi.toString().trim() === '') {
            errorMessage += 'Ana Adı Boş Olamaz!</br>';
        }

        if (memberInfo.babaAdi === null || memberInfo.babaAdi.toString().trim() === '') {
            errorMessage += 'Baba Adı Boş Olamaz!</br>';
        }

        if (memberInfo.cuzdanKimlikSeriNo === null || memberInfo.cuzdanKimlikSeriNo.toString().trim() === '') {
            errorMessage += 'Nüfus Cüzdanı/TC Kimlik Seri No Boş Olamaz!</br>';
        }


        if (memberInfo.dogumYeri === null || memberInfo.dogumYeri.toString().trim() === '') {
            errorMessage += 'Doğum Yeri Boş Olamaz!</br>';
        }


        if (memberInfo.dogumTarihi === null || memberInfo.dogumTarihi === '') {
            errorMessage += 'Dogum Tarihi Boş Olamaz!</br>';
        }


        if (memberInfo.medeniHali === null || memberInfo.medeniHali === '') {
            errorMessage += 'Medeni Hali Boş Olamaz!</br>';
        }

        if (memberInfo.city.id === null || memberInfo.city.id === '') {
            errorMessage += 'İl Boş Olamaz!</br>';
        }

        if (memberInfo.ikametAdres === null || memberInfo.ikametAdres.toString().trim() === '') {
            errorMessage += 'İkamet Adresi Boş Olamaz!</br>';
        }

        if (memberInfo.gsmTel === null || memberInfo.gsmTel.toString().trim() === '') {
            errorMessage += 'GSM Tel Boş Olamaz!</br>';
        }

        /* if(memberInfo.universite===null || memberInfo.universite.toString().trim()==='')
         {
             errorMessage += 'Üniversite Bilgisi Boş Olamaz!</br>'  ;
         }


         if(memberInfo.mezuniyetTarihi===null || memberInfo.mezuniyetTarihi==='')
         {
             errorMessage += 'Mezuniyet Tarihi Boş Olamaz!</br>'  ;
         }

         if(memberInfo.diplomaNo===null || memberInfo.diplomaNo.toString().trim()==='')
         {
             errorMessage += 'Diploma No Boş Olamaz!</br>'  ;
         }*/

        if (memberInfo.fotoFile === null || memberInfo.fotoFile === '') {
            errorMessage += 'Fotoğraf Yükleyiniz!</br>';
        }
        if (memberInfo.kimlikCuzdanFile === null || memberInfo.kimlikCuzdanFile === '') {
            errorMessage += 'Kimlik Resmi Yükleyiniz!</br>';
        }
        /*if(memberInfo.diplomaFile===null || memberInfo.diplomaFile==='')
        {
            errorMessage += 'Diploma Resmi Yükleyiniz!</br>'  ;
        }*/
        if (memberInfo.adliSicilFile === null || memberInfo.adliSicilFile === '') {
            errorMessage += 'Adli Sicil Belgesi Resmi Yükleyiniz!</br>';
        }
        if (memberInfo.ikametgahFile === null || memberInfo.ikametgahFile === '') {
            errorMessage += 'İkametgah Belgesi Resmi Yükleyiniz!</br>';
        }
        console.log(errorMessage);
        return errorMessage;
    }

    validateComponent() {
        let result = validateComponent();
        this.setState({
            error: result.error
        });
        return result
    }

    handleInfoChange(name, value) {
        // console.log("member handleInfoChange==>",name,value);
        let memberInfo = this.state.memberInfo;
        memberInfo[name] = value;
        this.setState({memberInfo});
        console.log(memberInfo);
    }

    handleCityInfoChange(name, value) {
        console.log(name, value);
        let cityInfo = this.state.memberInfo.city;
        cityInfo[name] = value;
        this.setState({cityInfo});
        console.log("city info==>", cityInfo);
    }

    handleStepValidation(name, value) {
        console.log(name, value);
        let validationInfo = this.state.validationInfo;
        validationInfo[name] = value;
        this.setState({validationInfo});
        console.log(validationInfo);
    }

    handleStepErrors() {
        let error = {};
        error = Object.assign(error, {["tAd"]: {valid: true, message: ""}});
        error = Object.assign(error, {["tSoyad"]: {valid: true, message: ""}});
        error = Object.assign(error, {["tTckNo"]: {valid: true, message: ""}});
        return error;
    }

    next() {
        const current = this.state.current + 1;
        this.setState({current});
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({current});
    }

    saveMember() {
        let self = this;
        let validity = this.validateMemberInfo();
        if (validity === '') {
            self.setState({isLoading: true});
            let member = deepCopyObject(this.state.memberInfo);
            let currentUser = deepCopyObject(this.state.currentUser);
            let message;
            let params;
            let data;
            member.user_id = currentUser.id;
            member.basvuruDurumu = "UYELIK_BILGILERININ_KONTROLU_BEKLENIYOR";
            //console.log("memberafterdeepcopy=>", member);
            data = member;
            if (data.id === undefined || data.id === null) {
                message = 'Uye Başvurusu Başarıyla Kaydedildi.'
                params = {
                    url: API_BASE_URL + "/uye",
                    data: data,
                    method: 'post'
                };
            } else {
                message = 'Uye Başvurusu Başarıyla Güncellendi.'
                params = {
                    url: API_BASE_URL + "/uye",
                    data: data,
                    method: 'put'
                };
            }
            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 10000
                    });
                self.setState({isLoading: false})
                this.props.history.push('/');
            }).catch(function (error) {
                self.setState({isLoading: false})
                showAxiosError(error);
            });
        } else {
            Alert.error(
                validity, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
        }
    }

    listCities() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city",
            method: "get",
        };
        console.log(params.url);
        request(params)
            .then(function (response) {
                console.log(response.data);
                let cities = response.data;
                self.setState({
                    cities,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    getMemberForEdit(currentUser) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/userId/" + currentUser.id,
            method: "get",
        };
        console.log(params.url);
        request(params)
            .then(function (response) {
                console.log(response.data);
                let memberInfo = response.data;

                memberInfo.dogumTarihi = (memberInfo.dogumTarihi !== null) ? moment.utc(memberInfo.dogumTarihi.substring(0, memberInfo.dogumTarihi.indexOf('T')), "YYYY-MM-DD") : null;
                memberInfo.kimlikSonGecerlilikTarihi = (memberInfo.kimlikSonGecerlilikTarihi !== null) ? moment.utc(memberInfo.kimlikSonGecerlilikTarihi.substring(0, memberInfo.kimlikSonGecerlilikTarihi.indexOf('T')), "YYYY-MM-DD") : null;
                memberInfo.mezuniyetTarihi = (memberInfo.mezuniyetTarihi !== null) ? moment.utc(memberInfo.mezuniyetTarihi.substring(0, memberInfo.mezuniyetTarihi.indexOf('T')), "YYYY-MM-DD") : null;
                memberInfo.ruhsatTarihi = (memberInfo.ruhsatTarihi !== null) ? moment.utc(memberInfo.ruhsatTarihi.substring(0, memberInfo.ruhsatTarihi.indexOf('T')), "YYYY-MM-DD") : null;

                console.log("member bound==>", memberInfo);
                self.handleStepValidation("citySelectionValid", true);
                self.handleStepValidation("contactInfoValid", true);
                self.handleStepValidation("fileUploadValid", true);
                self.handleStepValidation("personalInfoValid", true);
                self.handleStepValidation("ruhsatInfoValid", true);
                self.handleStepValidation("citySelectionError", self.handleStepErrors())

                self.setState({
                    memberInfo
                });
            }).catch(function (error) {
            showAxiosError(error);
        });

    }

    render() {
        const {current} = this.state;
        let enabled;
        const steps = [
            {
                title: 'Başlangıç',
                content: <CitySelection form={this.props.form} onInfoChange={this.handleInfoChange}
                                        memberInfo={this.state.memberInfo}
                                        cities={this.state.cities} onCityInfoChange={this.handleCityInfoChange}
                                        validationInfo={this.state.validationInfo}
                                        validateStep={this.handleStepValidation}/>,
            }, {
                title: 'Kişisel Bilgiler',
                content: <PersonalInfo form={this.props.form} onInfoChange={this.handleInfoChange}
                                       memberInfo={this.state.memberInfo}
                                       validationInfo={this.state.validationInfo}
                                       validateStep={this.handleStepValidation}/>,
            }, {
                title: 'İletişim Bilgileri',
                content: <ContactInfo form={this.props.form} onInfoChange={this.handleInfoChange}
                                      memberInfo={this.state.memberInfo}/>,
            }, {
                title: 'Ruhsat/Diploma Bilgileri',
                content: <RuhsatInfo form={this.props.form} onInfoChange={this.handleInfoChange}
                                     memberInfo={this.state.memberInfo}/>,
            }, {
                title: 'Dosya Yükleme',
                content: <FileUpload form={this.props.form} onInfoChange={this.handleInfoChange}
                                     memberInfo={this.state.memberInfo}/>,
            }, {
                title: 'Onay',
                content: <MemberApproval form={this.props.form} memberInfo={this.state.memberInfo}/>,
            }
        ];

        //console.log("current step",current);
        switch (current) {
            case 0:
                this.state.validationInfo.citySelectionValid ? enabled = true : enabled = false
                break;
            case 1:
                this.state.validationInfo.personalInfoValid ? enabled = true : enabled = false
                break;
            case 2:
                this.state.validationInfo.contactInfoValid ? enabled = true : enabled = false
                break;
            case 3:
                this.state.validationInfo.ruhsatInfoValid ? enabled = true : enabled = false
                break;
            case 4:
                this.state.validationInfo.fileUploadValid ? enabled = true : enabled = false
                break;
            default:
                enabled = false
        }

        return (
            <div>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="member-container">
                    <Steps current={current}>
                        {steps.map(item => <Step key={item.title} title={item.title}/>)}
                    </Steps>
                    <div className="steps-content">{steps[this.state.current].content}</div>
                    <div className="steps-action">
                        {
                            (this.state.current > 0)
                                ?
                                <Button type="secondary" style={{width: "75px"}}
                                        onClick={() => this.prev()}>Geri</Button>
                                :
                                <Button type="secondary" style={{width: "75px"}} disabled={true}
                                        onClick={() => this.prev()}>Geri</Button>

                        }
                        {
                            this.state.current === steps.length - 1 &&
                            (
                                //this.state.citySelectionValid && this.state.personalInfoValid && this.state.contactInfoValid && this.state.ruhsatInfoValid && this.state.fileUploadValid
                                this.state.infoValid
                                    ?
                                    <Button className="ant-btn-approval" disabled={this.state.isLoading}
                                            style={{width: "150px"}} onClick={() => this.saveMember()}>Başvuruyu
                                        Tamamla</Button>
                                    :
                                    <Button className="ant-btn-approval"
                                            style={{border: "1px solid red", width: "150px"}} disabled={true}
                                            onClick={() => this.saveMember()}>Başvuruyu Tamamla</Button>
                            )
                        }
                        {
                            this.state.current < steps.length - 1 && this.state.infoValid &&
                            (
                                (enabled)
                                    ?
                                    <Button type="primary" style={{width: "75px"}}
                                            onClick={() => this.next(steps[current])}>İleri</Button>
                                    :
                                    <Button type="primary" style={{width: "75px"}} disabled={true}
                                            onClick={() => this.next(steps[current])}>İleri</Button>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Member;


// WEBPACK FOOTER //
// ./src/page/member/Member.js